import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=52a4c42e&"
import script from "./Undo.vue?vue&type=script&lang=js&"
export * from "./Undo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports